import { render, staticRenderFns } from "./grupo_curricula_oferta.vue?vue&type=template&id=7ded1d4c&"
import script from "./grupo_curricula_oferta.vue?vue&type=script&lang=js&"
export * from "./grupo_curricula_oferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports